import * as cookieConsent from '@kerika/cookie-consent';

export const dueDateAction = (prev, next) => !next ? 'RESET' : !prev ? 'SET' : 'CHANGED';

export const assignmentChangeProps = (prev, next) => ({
  action: !next.length ? 'RESET' : !prev.length ? 'SET' : 'CHANGED',
  added_count: next.filter(a => !prev.includes(a)).length,
  removed_count: prev.filter(a => !next.includes(a)).length,
});

/**
 * Analytics is allowed only after the user has explicitly given consent and enabled analytics.
 * Defaults to disallowed (GDPR-compliant strict opt-in) until consent is taken.
 *
 * @returns {Boolean} true if analytics is allowed
 */
export const isAnalyticsAllowed = () => {
  const consentTaken = cookieConsent.isConsentTaken();
  const analyticsEnabled = cookieConsent.isAnalyticsEnabled();

  // If consent is taken, respect the user's choice
  if (consentTaken) {
    return analyticsEnabled;
  }

  return false;
};

/**
 * Parse Sentry DSN to extract organization and project information.
 * Sentry DSN format: https://{publicKey}@{host}/{projectId}
 * For Sentry.io hosted: https://{publicKey}@o{organizationId}.ingest.sentry.io/{projectId}
 *
 * @param {String} sentryDSN - The Sentry DSN string
 * @returns {Object} Object containing { organization, projectId, publicKey, host }
 *                   Returns empty object if DSN is invalid or not provided
 */
export const parseSentryDSN = (sentryDSN) => {
  if (!sentryDSN) {
    return {};
  }

  // Match Sentry DSN pattern
  const match = sentryDSN.match(/^https:\/\/([^@]+)@o?(\d+)?\.?([^/]+)\/(\d+)$/);

  if (!match) {
    console.warn('Invalid Sentry DSN format:', sentryDSN);
    return {};
  }

  const publicKey = match[1];
  const organizationId = match[2]; // May be undefined for non-standard hosts
  const host = match[3];
  const projectId = match[4];

  const result = {
    publicKey,
    host: organizationId ? `o${organizationId}.${host}` : host,
    projectId
  };

  // For Sentry.io, organization is numeric ID from subdomain
  if (organizationId) {
    result.organization = organizationId;
  }

  return result;
};
